module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f2-150x150.15a50f4d.webp";